import type { FileRetrieve } from '@openapi'

export const EMITS = [
  'closeFile',
  'pdfPageEnter',
  'pdfPageLeave',
  'downloadFile',
  'publishFile',
  'addToSharebox',
  'toggleNotes',
  'openFile',
  'showRecentFiles',
  'search',
  'savePagesMetadata',
  'hotspotClicked',
]

export type AnnotationType = 'text' | 'drawing' | 'freeformHighlight' | 'textHighlight' | 'eraser' | 'link'

export interface FileModel extends FileRetrieve {
  isDeleted: boolean
}

export interface ShareboxItem {
  id: string
  fileId: FileRetrieve['id']
  name: FileRetrieve['name']
  type: 'file' | 'page'
  pageIndex?: number
  thumbnailUrl?: string
}
